import { render, staticRenderFns } from "./tips_popup.vue?vue&type=template&id=f22bb118"
import script from "./tips_popup.vue?vue&type=script&lang=js"
export * from "./tips_popup.vue?vue&type=script&lang=js"
import style0 from "./tips_popup.vue?vue&type=style&index=0&id=f22bb118&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports